import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  container: {
    paddingTop: 24,

    [theme.breakpoints.up('sm')]: {
      paddingTop: 105,
    },
  },

  title: {
    color: '#040C14',
    fontSize: 40,
    fontWeight: 'bold',
    position: 'relative',

    '&::before': {
      position: 'absolute',
      content: "' '",
      width: 40,
      height: 2,
      backgroundColor: '#000000',
      bottom: -32,
      left: 0,
    },

    [theme.breakpoints.down('sm')]: {
      fontSize: 24,
    },
  },

  benefitsList: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '16px',

    [theme.breakpoints.up('lg')]: {
      gap: '50px',
      justifyContent: 'center',
    },

    [theme.breakpoints.up('xl')]: {
      gap: '95px 271px',
    },
  },
}));
